import script from "./AddressFormCard.vue?vue&type=script&setup=true&lang=js"
export * from "./AddressFormCard.vue?vue&type=script&setup=true&lang=js"

import "./AddressFormCard.vue?vue&type=style&index=0&id=5bddcd46&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bddcd46"]])

export default __exports__